import { loggerMiddleware } from './loggerMiddleware';
import { sagaMiddleware } from './sagaMiddleware';

export function getRootMiddleware() {
  return [sagaMiddleware, ...loggerMiddleware];
}
